import _ from 'lodash';

export default function getServices({ services, noParentIfChildren = false }) {
    return _.reduce(
        services,
        (result, currentService) => {
            let hasSelectedChildren;

            if (currentService.selected) {
                if (_.size(currentService.child_services)) {
                    _.forEach(currentService.child_services, (childService) => {
                        // get all selected child services
                        if (childService.selected) {
                            hasSelectedChildren = true;
                            result.push(childService);
                        }
                    });
                }

                // if !noParentIfChildren or if noParentIfChildren is true BUT there are
                // no selected children, add currentService to array
                if (!noParentIfChildren || (noParentIfChildren && !hasSelectedChildren)) {
                    // strip out the array from the parent - no need to send up this extra data
                    // eslint-disable-next-line no-param-reassign
                    currentService.child_services = [];
                    result.push(currentService);
                }
            }

            return result;
        },
        []
    );
}
